import React, { useState } from 'react';
import { TicketIcon, QrCodeIcon, ClockIcon } from 'lucide-react';
type Screen = 'home' | 'payments' | 'cards' | 'rewards';
type TabId = 'vouchers' | 'qr' | 'history';
interface BottomNavProps {
  activeScreen: Screen;
  onNavigate: (screen: Screen) => void;
  onQRScan?: () => void;
}
export function BottomNav({
  activeScreen,
  onNavigate,
  onQRScan
}: BottomNavProps) {
  const [activeTab, setActiveTab] = useState<TabId>('qr');
  const handleTabClick = (id: TabId) => {
    setActiveTab(id);
    if (id === 'vouchers') onNavigate('rewards');
    if (id === 'qr') onQRScan?.();
  };
  const iconColor = '#6B6B6B';
  const labelColor = '#4A4A4A';
  return <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 z-50" style={{
    width: 400,
    maxWidth: '100%',
    height: 91,
    background: '#FFFFFF',
    borderRadius: 5,
    // Inside-position 1px stroke at #000 6% — emulated via inset box-shadow
    boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.06)',
    fontFamily: 'Poppins, ui-sans-serif, system-ui, sans-serif',
    overflow: 'visible'
  }} data-id="element-293">
      <div className="w-full h-full flex items-center justify-between px-8 relative" data-id="element-294">
        {/* LEFT — Vouchers & Mini Apps */}
        <TabButton onClick={() => handleTabClick('vouchers')} labelColor={labelColor} label={'Vouchers\n& Mini Apps'} data-id="element-295">
          <TicketIcon style={{
          width: 28,
          height: 28
        }} strokeWidth={1.6} color={iconColor} data-id="element-296" />
        </TabButton>

        {/* CENTER — QR hero (elevated) */}
        <button onClick={() => handleTabClick('qr')} className="flex flex-col items-center justify-start active:scale-95 transition-transform" style={{
        flex: 1,
        minWidth: 0
      }} aria-label="QR" data-id="element-297">
          {/* Elevated QR circle */}
          <div style={{
          width: 60,
          height: 60,
          borderRadius: 999,
          background: '#FFFFFF',
          // 4px inside white border
          boxShadow: 'inset 0 0 0 4px #FFFFFF, 0 4px 20px rgba(200,75,17,0.10)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: -22
        }} data-id="element-298">
            <QrCodeIcon style={{
            width: 30,
            height: 30
          }} strokeWidth={1.8} color={iconColor} data-id="element-299" />
          </div>

          <span style={{
          fontSize: 12,
          fontWeight: 400,
          color: labelColor,
          marginTop: 8,
          textAlign: 'center',
          lineHeight: 1.2,
          fontFamily: 'Poppins, ui-sans-serif, system-ui, sans-serif'
        }} data-id="element-300">
            QR
          </span>
        </button>

        {/* RIGHT — Transaction History */}
        <TabButton onClick={() => handleTabClick('history')} labelColor={labelColor} label={'Transaction\nHistory'} data-id="element-301">
          <ClockIcon style={{
          width: 28,
          height: 28
        }} strokeWidth={1.6} color={iconColor} data-id="element-302" />
        </TabButton>
      </div>
    </nav>;
}
interface TabButtonProps {
  onClick: () => void;
  labelColor: string;
  label: string;
  children: React.ReactNode;
}
function TabButton({
  onClick,
  labelColor,
  label,
  children
}: TabButtonProps) {
  return <button onClick={onClick} className="flex flex-col items-center justify-center active:scale-95 transition-transform" style={{
    flex: 1,
    minWidth: 0,
    paddingLeft: 4,
    paddingRight: 4
  }} data-id="element-303">
      <div data-id="element-304">{children}</div>
      <span style={{
      fontSize: 12,
      fontWeight: 400,
      color: labelColor,
      marginTop: 8,
      textAlign: 'center',
      lineHeight: 1.2,
      letterSpacing: '0.01em',
      whiteSpace: 'pre-line',
      fontFamily: 'Poppins, ui-sans-serif, system-ui, sans-serif'
    }} data-id="element-305">
        {label}
      </span>
    </button>;
}